export default {
  mounted() {
    this.$nextTick(() => {
      this.aplicarEstiloObligatorio();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.aplicarEstiloObligatorio();
    });
  },
  methods: {
    aplicarEstiloObligatorio() {
      // Busca todos los labels de campos Vuetify
      document.querySelectorAll('.v-input .v-label').forEach(label => {
        if (label.innerText.includes('*')) {
          label.classList.add('campo-obligatorio');
        }
      });
    }
  }
};